export const HOME = '/';
export const ABOUT = '/about';
export const PROFILE = '/profile';
export const NEWITEM = '/newitem';
export const LOCATIONDRAGGER = '/locationdragger';
